<template lang="pug">
  div
    button(
      :class="clase == '' ? 'btn btn-sm btn-primary' : 'change-button'"
      :disabled="disabled || loading"
      v-b-modal.modal-cambio3x3
      title="Pedir Aprobación de 3x3"
      @hide="hideModal()")
      b-spinner(v-if="loading" small)
      span {{ loading ? 'Procesando...' : 'Pedir Aprobación de 3x3' }}
    b-modal.hide-foooter.adm-actions-modal(
      v-model="show" 
      id="modal-cambio3x3" 
      :title="`Aprobación 3x3 OT: ${ot.ot}`"
      @shown="onModalShown"
      @hide="onModalHide"
    )
      b-form-group(
        label-for="input-comentario-solicitud"
        label="Comentario:"
      )
        b-form-textarea(
          id="input-comentario-solicitud"
          v-model="comentario"
          rows=7
          placeholder="Ingrese su comentario"
        )
      label ¿Está seguro?
      template.botones(#modal-footer='{ ok, cancel, hide }')
        b-button(size='sm' variant='success' @click='createExcepcion3x3()' :disabled="loading") Aceptar
        b-button(size='sm' variant='danger' @click='hideModal()') Cancelar
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import LoadingButtonMixin from '@/mixins/LoadingButtonMixin'

export default {
  name: 'ActionCambio3x3',
  mixins: [LoadingButtonMixin],
  props: ['ot', 'disabled', 'size', 'variante', 'clase'],
  data() {
    return {
      show: false,
      saved: false,
      comentario: null,
    }
  },
  computed: {
    ...mapGetters('AuthenticationStore', ['user']),
  },
  methods: {
    ...mapActions('Exceptions', ['createExcepcion']),
    
    onModalShown() {
      // Evento cuando se muestra el modal
    },
    
    onModalHide() {
      // Evento cuando se oculta el modal
    },
    
    hideModal() {
      this.show = false
    },
    async createExcepcion3x3() {
      try {
        await this.executeWithLoading(async () => {
          const data = {
            orden_trabajo: this.ot.ot,
            tipo: 'Aprobación de 3x3',
            comentario_solicitud: this.comentario,
            solicitado_por: this.user.user.id,
          }
          const res = await this.createExcepcion(data)
          console.log(res.status)
          if (res.status === 200) {
            this.$bvToast.toast('Solicitud creada correctamente', {
              variant: 'success',
            })
            this.$emit('changed')
            this.hideModal()
          } else {
            this.$bvToast.toast(`Error al crear la solicitud: ${res.data}`, {
              variant: 'danger',
            })
          }
        })
      } catch (error) {
        console.error('Error al crear excepción 3x3:', error)
        this.$bvToast.toast('Error al crear la solicitud', {
          variant: 'danger',
        })
      }
    },
  },
}
</script>
